import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "folder-1" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M3.74935 2.5C2.59876 2.5 1.66602 3.43274 1.66602 4.58333V14.5833C1.66602 15.7339 2.59876 16.6667 3.74935 16.6667H16.2493C17.3999 16.6667 18.3327 15.7339 18.3327 14.5833V7.08333C18.3327 5.93274 17.3999 5 16.2493 5H10.8913C10.4734 5 10.0831 4.79112 9.85126 4.44338L9.17415 3.42771C8.78776 2.84813 8.13728 2.5 7.44071 2.5H3.74935Z",
        stroke: "#8E8E93",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }